import React, { useState } from "react";

import { Box, Card, Modal } from "@material-ui/core";
import { ErrorSharp } from "@material-ui/icons";
import Button from "@remar/shared/dist/components/Button";
import { format } from "date-fns";
import { useUpgradeForm } from "hooks/useUpgradeForm";
import { useHistory } from "react-router-dom";
import { RootState, useAppDispatch, useAppSelector } from "store";
import { getUserData, selectInactiveSubscription } from "store/features/Auth/authSlice";

import { getSubscriptionInfo, getUserInfo } from "store/features/MyAccount/myAccountSlice";

import { routes } from "core/constants";

import { PaymentBlock, PaymentDescription, PaymentTitle } from "./styles";

import UpgradeSubscription from "../MyAccount/UpgradeSubscription";

const NextBilling = () => {
	const history = useHistory();
	const dispatch = useAppDispatch();
	const [modal, setModal] = useState(false);
	const { subscriptionInfo } = useAppSelector((store: RootState) => store.myAccount);
	const { isRenewEnabled } = useAppSelector(selectInactiveSubscription);

	const onSubmit = () => {
		setModal(false);
		dispatch(getSubscriptionInfo());
		dispatch(getUserData());
		dispatch(getUserInfo());
		history.push(`${routes.course.getPath()}?refetch=true`);
	};

	const { closeModal, ...upgradeFormProps } = useUpgradeForm({ setModal, onSubmit, dispatch });

	const getNextBillingDate = () => {
		if (subscriptionInfo) {
			const date = subscriptionInfo!.upcomingInvoice!.billingDate!;
			return date && format(new Date(date), "MM.dd.yyyy");
		}
		return "";
	};

	return (
		<Card>
			<PaymentTitle>Your Next Billing</PaymentTitle>
			<PaymentBlock>
				{subscriptionInfo?.subscription.type?.isTrial ? (
					<>
						<Box display="flex" mb={1}>
							<ErrorSharp style={{ fill: "#898f9e" }} />
							<PaymentDescription>Your current subscription is trial</PaymentDescription>
						</Box>
						{!isRenewEnabled && (
							<Button color="primary" onClick={() => setModal(true)}>
								Upgrade
							</Button>
						)}
					</>
				) : (
					<>
						<Box display="flex" mb={1}>
							<ErrorSharp style={{ fill: "#898f9e" }} />
							<PaymentDescription>
								{`Your Next Payment will take place on ${getNextBillingDate()} and a total of ${
									subscriptionInfo?.upcomingInvoice.price
								}$.`}
							</PaymentDescription>
						</Box>
						<Button color="primary" onClick={() => history.push(routes.myAccount.getPath())}>
							Manage
						</Button>
					</>
				)}
				<Modal open={modal} onClose={closeModal}>
					<UpgradeSubscription {...upgradeFormProps} closeModal={closeModal} />
				</Modal>
			</PaymentBlock>
		</Card>
	);
};
export default NextBilling;
